<template>
  <b-container
    class="mb-5"
    fluid
  >
    <div class="d-flex justify-content-end mb-0 pb-0">
      <b-breadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <b-container fluid>
      <b-row>

        <b-col
          cols="12"
          class="px-1"
        >
          <b-form-group
            label="Search"
            label-for="filter_payment_nature"
            label-class="font-weight-bolder"
          >
            <b-input
              id="filter_payment_nature"
              v-model="tableBank.filter.search"
              type="text"
              placeholder="search here"
              debounce="1000"
              autocomplete="off"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          class="px-1 mb-2"
        >
          <b-button
            size="sm"
            type="button"
            variant="success"
            @click="onCreateBank"
          >
            Add Bank
          </b-button>
        </b-col>
      </b-row>

      <b-row class="mt-1">
        <b-col
          cols="12"
          class="px-1"
        >
          <b-table
            ref="tableBank"
            hover
            small
            striped
            bordered
            responsive
            show-empty
            :stacked="isMobile()"
            :per-page="tableBank.perPage"
            :current-page="tableBank.currentPage"
            :items="tableBankProvider"
            :fields="tableBank.fields"
            :sort-by.sync="tableBank.sortBy"
            :sort-desc.sync="tableBank.sortDesc"
            :sort-direction="tableBank.sortDirection"
            :filter="tableBank.filter"
            :filter-included-fields="tableBank.filterOn"
            :busy="tableBank.busy"
          >
            <template #cell(index)="row">
              {{ tableBank.currentPage * tableBank.perPage - tableBank.perPage + (row.index + 1) }}
            </template>

            <template #cell(active)="row">
              {{ Number(row.value) === 1 ? 'Yes' : 'No' }}
            </template>

            <template #cell()="row">
              <div class="text-md-nowrap">
                {{ row.value }}
              </div>
            </template>

            <template #cell(action)="row">
              <div class="text-md-nowrap d-flex flex-column flex-md-row justify-content-center">
                <b-button
                  size="sm"
                  variant="success"
                  @click="onEditBank(row.item)"
                >
                  Edit
                </b-button>
              </div>
            </template>

            <template #table-busy>
              <div class="text-center py-5">
                <b-icon
                  icon="stopwatch"
                  font-scale="5"
                  animation="cylon"
                />
                <p class="h3 py-2">
                  <strong>Loading . . .</strong>
                </p>
              </div>
            </template>

          </b-table>
        </b-col>

        <b-col
          cols="12"
          md="6"
          class="mt-1 mb-2 px-1"
        >
          <b-select
            v-model="tableBank.perPage"
            :options="tableBank.pageOptions"
            class="w-100 w-md-25"
          />
        </b-col>
        <b-col
          cols="12"
          md="6"
          class="d-flex justify-content-center justify-content-md-end mt-1 px-1"
        >
          <b-pagination
            v-model="tableBank.currentPage"
            pills
            last-number
            first-number
            prev-text="Prev"
            next-text="Next"
            aria-controls="table"
            :total-rows="tableBank.totalRows"
            :per-page="tableBank.perPage"
          />
        </b-col>
      </b-row>
    </b-container>

    <b-modal
      id="modal-bank"
      scrollable
      no-close-on-esc
      no-enforce-focus
      no-close-on-backdrop
      :title="ModalBankTitle"
    >
      <ValidationObserver
        ref="formBank"
      >
        <form
          role="form"
          novalidate
          @submit.prevent
        >
          <b-row>
            <b-col
              cols="12"
            >
              <ValidationProvider
                #default="{ errors }"
                name="bank name"
                vid="bank_name"
                rules="required|max:255"
              >
                <b-form-group
                  label="Bank Name"
                  label-for="bank_name"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <b-input
                    id="bank_name"
                    v-model="bank.bank_name"
                    type="text"
                    autocomplete="off"
                    maxlength="255"
                    placeholder="enter bank name here"
                    :state="errors.length > 0 ? false : null"
                    :disabled="state.busy"
                  />
                  <div
                    v-if="errors.length > 0"
                    class="invalid-feedback"
                  >
                    <span>{{ errors[0] }}</span>
                  </div>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col
              v-if="state.editing"
              cols="12"
            >
              <b-form-group>
                <b-form-checkbox
                  id="is_active"
                  v-model="bank.active"
                  switch
                  value="1"
                  name="is_active"
                  unchecked-value="0"
                  :disabled="state.busy"
                >
                  Is Active?
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>

        </form>
      </ValidationObserver>

      <template #modal-footer="{cancel}">
        <b-button
          variant="success"
          :disabled="state.busy"
          @click="onValidateBank"
        >
          {{ state.editing ? 'Update Record' : 'Save Record' }}
        </b-button>
        <b-button
          variant="outline-dark"
          :disabled="state.busy"
          @click="cancel()"
        >
          Close Window
        </b-button>
      </template>

    </b-modal>
  </b-container>
</template>

<script>
import QUERY from 'lodash'
import { core } from '@/config/pluginInit'
import { SAdminBank } from '@/services'
import formatter from '@/mixins/formatter'
import misc from '@/mixins/misc'

export default {
  name: 'AdminBanks',

  middleware: ['auth', 'admin'],

  mixins: [misc, formatter],

  metaInfo: () => ({
    title: 'Banks'
  }),

  data () {
    return {
      state: {
        busy: false,
        editing: false
      },
      bank: {
        id: null,
        bank_name: null,
        active: 1
      },
      tableBank: {
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        totalRows: 0,
        currentPage: 1,
        sortBy: null,
        sortDesc: false,
        sortDirection: 'asc',
        filter: {
          search: null
        },
        filterOn: [],
        busy: false,
        fields: [
          { mobile: 0, key: 'index', label: '#', class: 'text-center' },
          { mobile: 5, key: 'action', class: 'text-center' },
          { mobile: 1, key: 'created_at', formatter: this.dateTimeShortFormatter, sortable: true },
          { mobile: 2, key: 'bank_name' },
          { mobile: 3, key: 'active', class: 'text-center' },
          { mobile: 4, key: 'updated_at', formatter: this.dateTimeShortFormatter, sortable: true }
        ].sort(this.scaleOnMobile)
      }
    }
  },

  computed: {
    ModalBankTitle () {
      return this.state.editing ? 'Edit Bank' : 'Add Bank'
    }
  },

  mounted () {
    core.index()
  },

  methods: {
    async tableBankProvider ({ currentPage, perPage, sortBy, sortDesc, filter }) {
      this.tableBank.busy = true
      return await SAdminBank.get(
        this.objectToUrl({
          page: currentPage,
          per_page: perPage,
          sort: sortBy,
          sort_desc: sortDesc,
          filter_text: filter.search
        })
      ).then(({ data }) => {
        this.tableBank.totalRows = data.total_rows
        return data.items
      }).catch(() => []).finally(() => {
        this.tableBank.busy = false
      })
    },

    onCreateBank () {
      this.state.editing = false
      this.bank.id = null
      this.bank.bank_name = null
      this.bank.active = 1
      this.$bvModal.show('modal-bank')
    },

    onEditBank (bank) {
      this.state.editing = true
      this.bank.id = bank.id
      this.bank.bank_name = bank.bank_name
      this.bank.active = bank.active
      this.$bvModal.show('modal-bank')
    },

    async onValidateBank (event) {
      event.preventDefault()
      await this.$refs.formBank.validate().then(
        async allFieldsAreValid => {
          if (allFieldsAreValid) {
            this.swalConfirm({
              html: () => {
                if (this.state.editing) {
                  return '<h6>Save your changes on this Bank?</h6>'
                }
                return '<h6>Create this Bank?</h6>'
              },
              preConfirm: () => {
                this.state.busy = true
                if (this.state.editing) {
                  return this.onPutBank()
                }
                return this.onPostBank()
              }
            })
          } else {
            this.swalInvalid()
          }
        }
      )
    },

    async onPostBank () {
      return new Promise(resolve => {
        SAdminBank.post(this.bank).then(
          ({ data: { message } }) => {
            this.$refs.tableBank.refresh()
            this.swalSuccess(message).then(() => {
              this.$bvModal.hide('modal-bank')
            })
            resolve(message)
          }
        ).catch(({ message }) => {
          this.$refs.formBank.setErrors(message)
          resolve(message)
        }).finally(() => {
          this.state.busy = false
        })
      })
    },

    async onPutBank () {
      return new Promise(resolve => {
        SAdminBank.put(this.bank).then(
          ({ data }) => {
            const tableBankRow = QUERY.find(this.$refs.tableBank.localItems, { id: data.bank.id })
            if (tableBankRow) {
              tableBankRow.bank_name = data.bank.bank_name
              tableBankRow.active = data.bank.active
              tableBankRow.updated_at = data.bank.updated_at
            }
            this.swalSuccess(data.message).then(() => {
              this.$bvModal.hide('modal-bank')
            })
            resolve(data)
          }
        ).catch(({ message }) => {
          this.$refs.formBank.setErrors(message)
          resolve(message)
        }).finally(() => {
          this.state.busy = false
        })
      })
    }
  }
}
</script>
